module.exports = __webpack_public_path__ + "static/media/11-ball.9aed61fe.png";